import { Injectable } from '@angular/core';
import { Observable, of, pipe } from 'rxjs';
import { Site, SiteService } from '../site';
import { HttpClient } from '@angular/common/http';
import { catchError, filter, map, share, switchMap } from 'rxjs/operators';

export interface EditURLResponse {
  wsp_edit_url: string;
}

const DEFAULT_EDIT_PATH = '/wp-admin/edit.php?post_type=page';

@Injectable()
export class SiteEditService {
  editUrl$: Observable<string>;
  stagingEditUrl$: Observable<string>;

  constructor(private siteService: SiteService, private http: HttpClient) {
    this.editUrl$ = this.siteService.get().pipe(
      map((site: Site) => site.domain),
      this.fetchEditUrl(),
      share(),
    );
    this.stagingEditUrl$ = this.siteService.get().pipe(
      map((site: Site) => site.stagingDomain),
      filter((stagingDomain: string) => !!stagingDomain),
      this.fetchEditUrl(),
      share(),
    );
  }

  getEditUrl(): Observable<string> {
    return this.editUrl$;
  }

  getStagingEditUrl(): Observable<string> {
    return this.stagingEditUrl$;
  }

  private fetchEditUrl = () =>
    pipe(
      switchMap((domain) =>
        this.http.get('https://' + domain + '/?rest_route=/website-pro/v1/site/options&wsp_edit_url'),
      ),
      map((resp: EditURLResponse) => (resp && resp.wsp_edit_url ? resp.wsp_edit_url : DEFAULT_EDIT_PATH)),
      catchError(() => of(DEFAULT_EDIT_PATH)),
    );
}
